export enum WidgetType {
  GroupsPage = 'GroupsPage',
  ListWidget = 'ListWidget',
  SideBySide = 'SideBySide',
}
